// Authorization document text constants for Recruitment Application Details

export const BACKGROUND_CHECK_TEXT = `I hereby authorize the above named company to release any and all information to Kranawetter Transport, LLC concerning my performance, conduct, accident record and all required DOT drug and alcohol related information while previously employed as a commercial motor vehicle operator in the previous 3 years from the date of this form as specified and required by the Federal Motor Carrier Safety Regulations, Part 391.23 investigation and inquiries. In connection with, and for the duration of, my employment (including contract for services) with you, I understand that investigative background inquiries are to be made on myself including consumer, driving, and other reports. This information will, in whole or in part, be obtained from COTA, A Part of National Compliance Solutions Inc., 1011 Camino Del Rio South, Suite 200, San Diego, CA 888.908.2382. These reports will include information as to my work habits, performance and experience along with reasons for termination of past employment from previous employers. Further, I understand that you will be requesting information from various federal, state and other agencies which maintain records concerning my past activities relating to my driving, credit, civil and other experiences as well as claims involving me in the files of insurance companies. This release may also be used to obtain worker's compensation and education records.

By signing below, I also acknowledge that I have read and understand the summary of my rights under The Fair Credit Reporting Act Pub. L. 111-203, H.R. 4173.

Notice to California Applicants: Under Section 1786.22 of the California Civil Code, you have the right to request from CDTA, upon proper identification, the nature and substance of all information in its files on you, including the sources of information, and the recipients of any reports on you which COTA has previously furnished within the two-year period preceding your request. You may view the file maintained on you by CDTA during normal business hours. You may also obtain a copy of this file upon submitting proper identification and paying the costs of duplication services. Upon making a written request, you may receive a summary report via telephone. California, Minnesota & Oklahoma Applicants only: Please check here to have a copy of your consumer report sent directly to you. Minnesota & Oklahoma applicants receive a copy direct from CDTA. California applicants may receive a copy from either the prospective employer or CDTA.`;

export const PSP_TEXT = `IMPORTANT DISCLOSURE

REGARDING BACKGROUND REPORTS FROM THE PSP Online Service

In connection with your application for employment with Kranawetter Transport LLC ("Prospective Employer"), Prospective

Employer, its employees, agents or contractors may obtain one or more reports regarding your driving, and safety inspection history

from the Federal Motor Carrier Safety Administration (FMCSA).

When the application for employment is submitted in person, if the Prospective Employer uses any information it obtains from FMCSA

in a decision to not hire you or to make any other adverse employment decision regarding you, the Prospective Employer will provide

you with a copy of the report upon which its decision was based and a written summary of your rights under the Fair Credit Reporting

Act before taking any final adverse action. If any final adverse action is taken against you based upon your driving history or safety

report, the Prospective Employer will notify you that the action has been taken and that the action was based in part or in whole on this

report.

When the application for employment is submitted by mail, telephone, computer, or other similar means, if the Prospective Employer

uses any information it obtains from FMCSA in a decision to not hire you or to make any other adverse employment decision regarding

you, the Prospective Employer must provide you within three business days of taking adverse action oral, written or electronic

notification: that adverse action has been taken based in whole or in part on information obtained from FMCSA; the name, address, and

the toll free telephone number of FMCSA; that the FMCSA did not make the decision to take the adverse action and is unable to provide

you the specific reasons why the adverse action was taken; and that you may, upon providing proper identification, request a free copy

of the report and may dispute with the FMCSA the accuracy or completeness of any information or report. If you request a copy of a

driver record from the Prospective Employer who procured the report, then, within 3 business days of receiving your request, together

with proper identification, the Prospective Employer must send or provide to you a copy of your report and a summary of your rights

under the Fair Credit Reporting Act.

Neither the Prospective Employer nor the FMCSA contractor supplying the crash and safety information has the capability to correct

any safety data that appears to be incorrect. You may challenge the accuracy of the data by submitting a request to

https://dataqs.fmcsa.dot.gov. If you challenge crash or inspection information reported by a State, FMCSA cannot change or correct this

data. Your request will be forwarded by the DataQs system to the appropriate State for adjudication.

Any crash or inspection in which you were involved will display on your PSP report. Since the PSP report does not report, or assign, or

imply fault, it will include all Commercial Motor Vehicle (CMV) crashes where you were a driver or co-driver and where those crashes

were reported to FMCSA, regardless of fault. Similarly, all inspections, with or without violations, appear on the PSP report. State

citations associated with Federal Motor Carrier Safety Regulations (FMCSR) violations that have been adjudicated by a court of law

will also appear, and remain, on a PSP report.

The Prospective Employer cannot obtain background reports from FMCSA without your authorization.

AUTHORIZATION

If you agree that the Prospective Employer may obtain such background reports, please read the following and sign below:

I authorize Kranawetter Transport LLC ("Prospective Employer") to access the FMCSA Pre-Employment Screening Program (PSP)

system to seek information regarding my commercial driving safety record and information regarding my safety inspection history. I

understand that I am authorizing the release of safety performance information including crash data from the previous five (5) years

and inspection history from the previous three (3) years. I understand and acknowledge that this release of information may assist the

Prospective Employer to make a determination regarding my suitability as an employee.

I further understand that neither the Prospective Employer nor the FMCSA contractor supplying the crash and safety information has

the capability to correct any safety data that appears to be incorrect. I understand I may challenge the accuracy of the data by

submitting a request to https://dataqs.fmcsa.dot.gov. If I challenge crash or inspection information reported by a State, FMCSA cannot

change or correct this data. I understand my request will be forwarded by the DataQs system to the appropriate State for adjudication.

I understand that any crash or inspection in which I was involved will display on my PSP report. Since the PSP report does not report,

or assign, or imply fault, I acknowledge it will include all CMV crashes where I was a driver or co-driver and where those crashes

were reported to FMCSA, regardless of fault. Similarly, I understand all inspections, with or without violations, will appear on my

PSP report, and State citations associated with FMCSR violations that have been adjudicated by a court of law will also appear, and

remain, on my PSP report.

Kranawetter Transport LLC

Kranawetter Transport LLC

I have read the above Disclosure Regarding Background Reports provided to me by Prospective Employer and I understand that if I

sign this Disclosure and Authorization, Prospective Employer may obtain a report of my crash and inspection history. I hereby

authorize Prospective Employer and its employees, authorized agents, and/or affiliates to obtain the information authorized above.

NOTICE: This form is made available to monthly account holders by NIC on behalf of the U.S. Department of Transportation,

Federal Motor Carrier Safety Administration (FMCSA). Account holders are required by federal law to obtain an Applicant’s written

or electronic consent prior to accessing the Applicant’s PSP report. Further, account holders are required by FMCSA to use the

language contained in this Disclosure and Authorization form to obtain an Applicant’s consent. The language must be used in whole,

exactly as provided. Further, the language on this form must exist as one stand-alone document. The language may NOT be included

with other consent forms or any other language.

NOTICE: The prospective employment concept referenced in this form contemplates the definition of “employee” contained at 49

C.F.R. 383.5.

LAST UPDATED 2/11/2016`;


